export default "__VITE_ASSET__DZjSNGDR__"